// import serverApi from 'services/serverApi'
import store from 'store'

export default async function getMenuData() {
  console.log(`inside menu rendering`)
  const menuStore = store.get(`app.menu`)
  console.log(`redered menu from store ${menuStore}`)
  return menuStore || []
}
